import React from 'react';
import { useState } from 'react';
import { getArrayOfErrors } from 'utils/errors';
import { Box, InputAdornment, OutlinedInput, TextField, Typography } from '@mui/material';
import CTA from '../../../CTA';
import { flashQuote } from '../../../../api/marcketPlace';
import { useSelector, useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import AuthQuoteModal from '../QuickRegister/AuthQuoteModal';
import { registerMarketplace, verify, login } from '../../../../api/auth';
import { createRestaurantPasswordByMarketplace } from '../../../../api/restaurants';
import { LoginV } from '../../../../redux/slices/authSlice/thunksV2';


const QuoteFlash = ({
    item,
    setShowModal,
    onClick

}) => {
   
    const { restaurant, user, token } = useSelector((state) => state.auth)
    const dispatch = useDispatch();
    const [checked, setChecked] = React.useState(false);
    const [canti, setCant] = React.useState(null);
    const [nota, setNota] = React.useState(null);
    const [isLoading, setIsloading] = useState(false)
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [registeredUserId, setRegisteredUserId] = useState(null);
    const [registeredPhone, setRegisteredPhone] = useState(null);
    const [registeredPassword, setRegisteredPassword] = useState(null);

    const handleSubmit = async (itemToQuote, quantity = canti, noteText = nota) => {
        if (!user || !token) {
            const quoteData = {
                item: itemToQuote,
                quantity: quantity,
                note: noteText,
                checked: checked,
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('pendingQuote', JSON.stringify(quoteData));
            setShowAuthModal(true);
            return;
        }

        setIsloading(true);
        const data = [{
            supplierId: itemToQuote.supplierId.toString(),
            anonymous: checked,
            note: noteText,
            products: [{
                productId: itemToQuote.id,
                quantity: parseInt(quantity)
            }]
        }];

        try {
            await flashQuote(token, user.id, restaurant, data);
            toast.success('Cotización enviada de manera correcta');
            setTimeout(() => {
                setShowModal(false);
                setIsloading(false);
            }, 500);
        } catch (error) {
            if (error.response) {
                const errors = getArrayOfErrors(error.response.data);
                errors.forEach(err => toast.error(err));
            } else {
                toast.error('Error al enviar cotización');
            }
            setShowModal(false);
            setIsloading(false);
        }
    };

    const handleRegister = async (formData, onSuccess) => {
        setIsloading(true);
        try {
            const payload = {
                restaurantIdentifier: formData.ruc,
                restaurantName: formData.razonSocial,
                phone: formData.telefono,
                userName: '',
                email: '',
                password: ''
            };
            
            const response = await registerMarketplace(payload);
            
            if (response.data) {
                const userId = response.data.userId;
                
                if (userId) {
                    setRegisteredUserId(userId);
                    setRegisteredPhone(formData.telefono);
                    
                    toast.success('Registro exitoso! Por favor verifica el código enviado a tu teléfono.');
                    setIsloading(false);
                    
                    if (onSuccess) {
                        onSuccess(userId);
                    }
                } else {
                    toast.error('Error: No se recibió el ID de usuario del servidor. Por favor contacta a soporte.');
                    setIsloading(false);
                }
            } else {
                toast.error('Error: Respuesta inválida del servidor.');
                setIsloading(false);
            }
            
        } catch (error) {
            setIsloading(false);
            
            if (error.response && error.response.data) {
                const errorData = error.response.data;
                
                if (errorData.restaurantIdentifier || errorData.phone || 
                    (typeof errorData === 'string' && (
                        errorData.toLowerCase().includes('ruc') || 
                        errorData.toLowerCase().includes('identificación') ||
                        errorData.toLowerCase().includes('identificacion') ||
                        errorData.toLowerCase().includes('teléfono') ||
                        errorData.toLowerCase().includes('telefono') ||
                        errorData.toLowerCase().includes('phone')
                    ))) {
                    
                    toast.error('El RUC o el teléfono ya están registrados. Por favor inicia sesión.');
                    setTimeout(() => {
                        window.location.href = '/ingreso';
                    }, 2000);
                } else if (error.response.status === 404) {
                    toast.error('El servicio de registro aún no está disponible. Por favor, inicia sesión si ya tienes cuenta.');
                    setTimeout(() => {
                        window.location.href = '/ingreso';
                    }, 2000);
                } else {
                    const errors = getArrayOfErrors(errorData);
                    errors.forEach(err => toast.error(err));
                }
            } else if (error.message) {
                toast.error('Error al registrar. Por favor intenta nuevamente.');
            } else {
                toast.error('Error al registrar. El servicio no está disponible.');
            }
        }
    };

    const handleVerifyCode = async (code, phone, onSuccess) => {
        setIsloading(true);
        try {
            const verifyObject = { code, phone };
            const response = await verify(verifyObject);
            
            toast.success('¡Código verificado exitosamente!');
            setIsloading(false);
            
            // SIEMPRE usar el userId que guardamos del registro
            if (registeredUserId) {
                if (onSuccess) {
                    onSuccess(registeredUserId);
                }
            } else {
                const userId = response.data?.userId || response.data?.id || response.data?.user?.id;
                
                if (userId) {
                    if (onSuccess) {
                        onSuccess(userId);
                    }
                } else {
                    toast.error('Error: No se pudo obtener el ID de usuario. Por favor contacta a soporte.');
                }
            }
            
        } catch (error) {
            setIsloading(false);
            if (error.response && error.response.data) {
                const errors = getArrayOfErrors(error.response.data);
                errors.forEach(err => toast.error(err));
            } else {
                toast.error('Error al verificar el código. Por favor intenta nuevamente.');
            }
        }
    };

    const handleSetPassword = async (userId, password) => {
        setIsloading(true);
        
        if (!userId) {
            toast.error('Error: No se puede establecer la contraseña sin un ID de usuario.');
            setIsloading(false);
            return;
        }
        
        try {
            const response = await createRestaurantPasswordByMarketplace(userId, { password });
            
            // Guardar la contraseña para el auto-login
            setRegisteredPassword(password);
            
            toast.success('¡Contraseña establecida exitosamente! Iniciando sesión...');
            
            // Auto-login del usuario
            if (registeredPhone) {
                try {
                    await dispatch(LoginV({ phone: registeredPhone, password: password }));
                    
                    // Cerrar modal y mostrar mensaje de éxito
                    setTimeout(() => {
                        setShowModal(false);
                        setShowAuthModal(false);
                        toast.success('¡Bienvenido! Has iniciado sesión exitosamente.');
                    }, 1000);
                } catch (loginError) {
                    console.error('Error al iniciar sesión automáticamente:', loginError);
                    toast.error('Cuenta creada. Por favor inicia sesión manualmente.');
                    setTimeout(() => {
                        window.location.href = '/ingreso';
                    }, 1500);
                }
            } else {
                toast.error('Error: No se pudo obtener el teléfono para iniciar sesión.');
                setTimeout(() => {
                    window.location.href = '/ingreso';
                }, 1500);
            }
            
        } catch (error) {
            setIsloading(false);
            
            if (error.response && error.response.data) {
                const errors = getArrayOfErrors(error.response.data);
                errors.forEach(err => toast.error(err));
            } else {
                toast.error('Error al establecer la contraseña. Por favor intenta nuevamente.');
            }
        }
    };

    if (showAuthModal) {
        return (
            <AuthQuoteModal
                onRegister={handleRegister}
                onVerifyCode={handleVerifyCode}
                onSetPassword={handleSetPassword}
                isLoading={isLoading}
            />
        );
    }

    return (
       <Box>
            <Typography fontSize={23} fontWeight={'bold'} >{ item.name }</Typography>
            <Typography fontSize={17} fontWeight={'bold'} color={'#000000'} >{ item.measurementUnit }</Typography>
            <Typography fontSize={15}  >{ item.category }</Typography>
            <Typography fontSize={15} fontWeight={'bold'} color={'#6d6d6d'} >{ item.supplier }</Typography>
           

            <Box mt={3} display={'flex'} flexDirection={'column'}>
              <Typography>Cantidad a ordenar (Mensual)</Typography>
              <OutlinedInput
                  onChange={( e)=>setCant(e.target.value)}
                  id="outlined-adornment-weight"
                  endAdornment={<InputAdornment style={{ marginRight:15 }} position="end">/{ item.measurementUnit}</InputAdornment>}
                  size='small'
                  value={!canti ? '' : canti}          
                  aria-describedby="outlined-weight-helper-text"
                  type='number'
                  inputProps={{
                    'aria-label': 'weight',
                  }}
                />
             <Box ml={1} >
            {/* <Typography> { item.measurementUnit } </Typography> */}
            </Box>
           
            </Box>
            <Box mt={3} display={'flex'} flexDirection={'column'}>
              <Typography>Notas</Typography>
            <TextField 
                onChange={( e)=>setNota(e.target.value)}
                value={!nota ? '' : nota}                
                multiline
                size='small'
            />
            <Box ml={1} >
            {/* <Typography> { item.measurementUnit } </Typography> */}
            </Box>
           
            </Box>

            <Box mt={3} >
                <CTA
                    isDisabled={ canti === null || isLoading ? true :  false }
                    onClick={()=>handleSubmit(item) }
                    text='Cotizar'
                />
            </Box>

       </Box>
    );
};



export default QuoteFlash;
